export const FormSection = ({ title, children, className }) => {
  return (
    <div className={`mb-8 ${className}`}>
      <h2 className="bg-green-700 text-white text-base md:text-lg font-medium py-2 px-4 rounded-t-lg ">
        {title}
      </h2>
      <div className="bg-white p-6 text-sm md:text-base rounded-b-lg grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {children}
      </div>
    </div>
  );
};

export const FormSection2 = ({ title, children, className }) => {
  return (
    <div className={`mb-8 ${className}`}>
      <h2 className="bg-green-700 text-white font-medium py-2 px-4 rounded-t-lg text-base md:text-lg">
        {title}
      </h2>
      <div className="bg-white p-6 pl-10 rounded-b-lg gap-4">{children}</div>
    </div>
  );
};

export const FormGroup = ({
  label,
  name,
  type,
  options,
  fullWidth,
  disabled,
  checked,
  onChange,
  value,
  className,
  errorMessage,
  id,
}) => {
  return (
    <div
      className={`flex flex-col ${
        fullWidth ? "md:col-span-2 lg:col-span-3" : ""
      }`}
    >
      <label htmlFor={id} className="mb-2 font-medium text-gray-700">
        {label}
      </label>
      {type === "select" ? (
        <select
          id={id}
          name={name}
          className={`p-2 border border-gray-300 rounded ${className}`}
          disabled={disabled}
          onChange={onChange}
          value={value}
        >
          {options.map((option, index) => (
            <option key={index} value={option}>
              {option}
            </option>
          ))}
        </select>
      ) : type === "checkbox" ? (
        <div className="flex items-center ml-6">
          <input
            type="checkbox"
            id={id}
            checked={checked}
            onChange={onChange}
            className="h-5 w-5 text-green-600 focus:ring-green-500 border-gray-300 rounded"
          />
          <label
            htmlFor={id}
            className="ml-4 font-semibold text-green-700 text-base"
          >
            {label}
          </label>
        </div>
      ) : (
        <input
          id={id}
          type={type}
          className={`p-2 border  border-gray-300 rounded ${className} ${
            errorMessage ? "border-red-500" : "border-gray-300"
          }`}
          disabled={disabled}
          onChange={onChange}
          value={value}
        />
      )}
      {errorMessage && (
        <span className="text-red-500 text-xs md:text-sm">{errorMessage}</span>
      )}
    </div>
  );
};
